import { Autocomplete, TextField, createFilterOptions } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { storeLocation } from '../../../../redux/actions/countries'
import { IRootState } from '../../../../redux/types'
import useModalState from '../../hooks/useModalState'
import { AddItemToAutocompleteModal } from './AddItemToAutocompleteModal'

interface ILocation {
  inputName: string
  name: string
  province: any
}

interface IPostalcode {
  id: number
  name: string
  province_id: number
}

const filter = createFilterOptions()

function PostalcodeAutocomplete({ value, province, handleInputChange }: any) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { open, openModal, closeModal } = useModalState()
  const { postalcodes } = useSelector((state: IRootState) => state.country)
  const [createLocation, setCreateLocation] = useState<ILocation>({
    inputName: '',
    name: '',
    province: null
  })

  const handleClose = () => {
    setCreateLocation({
      inputName: '',
      name: '',
      province: null
    })

    closeModal()
  }

  const handleSubmit = (event: any) => {
    event.preventDefault()
    dispatch(storeLocation(createLocation))

    handleClose()
  }

  const handleAutoCompleteChange = (postalcode: IPostalcode | null) => {
    handleInputChange('postalcode', postalcode)
  }

  return (
    <>
      <AddItemToAutocompleteModal<ILocation>
        open={open}
        value={createLocation}
        setValue={setCreateLocation}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
      />

      <Autocomplete
        value={value}
        onChange={(_, newValue) => {
          if (typeof newValue === 'string') {
            // timeout to avoid instant validation of the dialog's form.
            setTimeout(() => {
              openModal()
              setCreateLocation({
                inputName: 'postalcode',
                name: newValue,
                province: province
              })
            })
          } else if (newValue?.inputValue) {
            openModal()
            setCreateLocation({
              inputName: 'postalcode',
              name: newValue.inputValue,
              province: province
            })
          } else {
            handleAutoCompleteChange(newValue)
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params)
          if (params.inputValue !== '') {
            filtered.push({
              inputValue: params.inputValue,
              code: `${t('add')} "${params.inputValue}"`
            })
          }

          return filtered
        }}
        id="autocomplete-postalcodes"
        options={province !== null ? postalcodes.filter((postalcode: any) => postalcode.province_id === province.id) : []}
        getOptionLabel={option => {
          // e.g value selected with enter, right from the input
          if (typeof option === 'string') {
            return option
          }
          if (option.inputValue) {
            return option.inputValue
          }
          return option.id !== undefined ? option.code : ''
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(props, option) => {
          const { key, ...optionProps } = props
          return (
            <li key={key} {...optionProps}>
              {option.code}
            </li>
          )
        }}
        freeSolo
        renderInput={params => <TextField {...params} label={t('postal-code')} variant="filled" InputLabelProps={{ shrink: true }} />}
      />
    </>
  )
}

export default PostalcodeAutocomplete
